import React from "react";
import { Route, Switch } from "react-router-dom";

import NotFound from "../pages/NotFound";
import SignIn from "../pages/signin";
import Profile from "../pages/profile";

import AddQuiz from "../pages/quizzes/add";
import EditQuiz from "../pages/quizzes/edit";
import ViewQuiz from "../pages/quizzes/view";
import Quizzes from "../pages/quizzes/quiz/index";

import AddQuestion from "../pages/quizzes/addquestion";
import Reports from "../pages/quizzes/quiz/reports";
import Answers from "../pages/quizzes/quiz/answers";
import Quiz from "../pages/quiz/quiz";
import Thankyou from "../pages/thankyou/thankyou";
import Result from "../pages/result/result";
import Home from "../pages/home/home";
import Register from "../pages/register/register";
import ViewReports from "../pages/result/viewReports";
import LogIn from "../pages/login";
import SignUp from "../pages/signUp";
import ClientProfile from "../pages/clientProfile";
import QuizDetails from "../pages/quizDetails";
import ViewResult from "../pages/result/viewResult";
import LazyLoad from "../pages/home/lazyLoad";

const Routes = () => {
  return (
    <Switch>
      <Route path={`/`} exact component={Home} />
      <Route path={`/register`} exact component={Register} />
      <Route path={`/quiz`} exact component={Quiz} />
      <Route path={`/thankyou`} exact component={Thankyou} />
      <Route path={`/result`} exact component={Result} />
      <Route path={'/admin'} exact component={SignIn} />
      <Route path={`/admin/login`} exact component={SignIn} />
      <Route path={`/admin/profile`} exact component={Profile} />
      <Route path={`/admin/dashboard`} exact component={Quizzes} />
      <Route path={`/admin/addquiz`} exact component={AddQuiz} />
      <Route path={`/admin/editquiz/:quizid`} exact component={EditQuiz} />
      <Route path={`/admin/viewquiz/:quizid`} exact component={ViewQuiz} />
      <Route path={`/admin/addquestion/:id`} exact component={AddQuestion} />
      <Route path={`/admin/reports`} exact component={Reports} />
      <Route path={`/admin/answers`} exact component={Answers} />
      <Route path={`/viewreports/:id`} exact component={ViewReports}/>
      <Route path={`/login`} exact component={LogIn}/>
      <Route path={`/signup`} exact component={SignUp}/>
      <Route path={`/image`} exact component={LazyLoad}/>
      <Route path={`/clientprofile`} exact component={ClientProfile}/>
      <Route path={`/quizdetails`} exact component={QuizDetails}/>
      <Route path={`/viewresult/:id`} exact component={ViewResult}/>
      <Route path={`*`} component={NotFound} />
    




    </Switch>
  );
};

export default Routes;
